import { PageTitle } from 'components/PageTitle'
import { SpinnerWithLogo } from 'components/Spinner'
import { useRootStore } from 'hooks/rootStore'
import { useQueryParams } from 'hooks/router'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { z } from 'zod'
import { useTranslationTyped } from 'i18n/i18n'

const payloadSchema = z.object({
  id_token: z.string().optional(),
  endpoint: z.string().optional(),
})

export const LtiLoaderPage = observer(function LtiLoaderPage() {
  const rootStore = useRootStore()
  const rawParams = useQueryParams()
  const parsed = payloadSchema.safeParse(rawParams)
  const params = parsed.data
  const id_token = params?.id_token
  const endpoint = params?.endpoint
  const { tt } = useTranslationTyped()

  useEffect(() => {
    if (!endpoint) return
    fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify({ id_token_resent: id_token, from_loader: true }),
      redirect: 'error',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(async (res) => {
        const body = await res.json()
        const url = new URL(body.url)

        const target = url.pathname + url.search

        rootStore.navigateToUrl(target)
      })
      .catch((err) => {
        console.error(err)
      })
  }, [id_token, endpoint, rootStore])

  return (
    <div className="lti-configuration flex min-h-full w-full">
      <PageTitle title={tt.lti.page_title()} />
      <div className="">
        <img
          src="/assets/images/logo.png"
          width={64}
          className="absolute right-8 top-8"
          alt={tt.breakout_learning()}
        />
      </div>
      <div className="lti-plant flex min-h-full w-full flex-col items-center justify-center">
        <SpinnerWithLogo />
      </div>
      <form action={endpoint?.toString()} method="post" id="ltiLaunchForm">
        <input
          type="hidden"
          name="id_token_resent"
          value={id_token?.toString()}
        />
        <input type="hidden" name="from_loader" value="true" />
      </form>
    </div>
  )
})
